var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { CreateUserDocument, SearchUserDocument, UserpoolDocument, UpdateUserpoolDocument, ResetPasswordDocument, CheckPasswordStrengthDocument, RegisterByEmailDocument, RegisterByUsernameDocument, AssignRoleDocument, IsActionAllowedDocument, IsActionDeniedDocument, CreateRoleDocument, LoginByEmailDocument, LoginByUsernameDocument, LoginByPhoneCodeDocument, LoginByPhonePasswordDocument, OrgDocument, AddMemberDocument, SendEmailDocument, UsersDocument, UserDocument, RolesDocument, GroupsDocument, UpdateUserDocument, DeleteUserDocument, DeleteUsersDocument, RoleDocument, RoleWithUsersDocument, UpdateRoleDocument, OrgsDocument, CreateOrgDocument, UpdateNodeDocument, DeleteNodeDocument, MoveNodeDocument, NodeByIdWithMembersDocument, NodeByCodeWithMembersDocument, RemoveMemberDocument, RevokeRoleDocument, ChildrenNodesDocument, RefreshTokenDocument, AddUserToGroupDocument, RegisterByPhoneCodeDocument, UpdatePasswordDocument, UpdatePhoneDocument, UpdateEmailDocument, BindPhoneDocument, UnbindPhoneDocument, UserBatchDocument, GetUserRolesDocument, AllowDocument, WhitelistDocument, RemoveWhitelistDocument, AddWhitelistDocument, UdfDocument, UdvDocument, SetUdvDocument, RemoveUdvDocument, SetUdfDocument, RemoveUdfDocument, DeleteRoleDocument, DeleteRolesDocument, PoliciesDocument, CreatePolicyDocument, PolicyDocument, UpdatePolicyDocument, DeletePolicyDocument, DeletePoliciesDocument, PolicyAssignmentsDocument, AddPolicyAssignmentsDocument, RemovePolicyAssignmentsDocument, DeleteOrgDocument, RootNodeDocument, IsRootNodeDocument, IsUserExistsDocument, CheckLoginStatusDocument, GroupDocument, CreateGroupDocument, UpdateGroupDocument, DeleteGroupsDocument, RemoveUserFromGroupDocument, GroupWithUsersDocument, GetUserGroupsDocument, UnbindEmailDocument, AccessTokenDocument, EnablePolicyAssignmentDocument, DisbalePolicyAssignmentDocument, NodeByIdDocument, SetUdvBatchDocument, LoginBySubAccountDocument, ArchivedUsersDocument, AddNodeV2Document, FindUserDocument, GetUserDepartmentsDocument, SetMainDepartmentDocument, BindEmailDocument, ListUserAuthorizedResourcesDocument, UdfValueBatchDocument, SetUdfValueBatchDocument, ListRoleAuthorizedResourcesDocument, ListGroupAuthorizedResourcesDocument, ListNodeByIdAuthorizedResourcesDocument, ListNodeByCodeAuthorizedResourcesDocument, AuthorizedResourcesDocument, AuthorizeResourceDocument, AuthorizedTargetsDocument, UsersWithCustomDataDocument, UserWithCustomDataDocument, UserBatchWithCustomDataDocument, FindUserWithCustomDataDocument, SearchUserWithCustomDataDocument, RoleWithUsersWithCustomDataDocument, GroupWithUsersWithCustomDataDocument, MoveMembersDocument, SearchNodesDocument, ResetPasswordByFirstLoginTokenDocument, SendFirstLoginVerifyEmailDocument, ResetPasswordByForceResetTokenDocument } from '../types/graphql.v2';
export var isAllowed = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = IsActionAllowedDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [4 /*yield*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var getChildrenNodes = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = ChildrenNodesDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [4 /*yield*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var org = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = OrgDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [4 /*yield*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var isRootNode = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = IsRootNodeDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [4 /*yield*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var rootNode = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = RootNodeDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [4 /*yield*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var orgs = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = OrgsDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [4 /*yield*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var getUserPoolDetail = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = UserpoolDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [4 /*yield*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var user = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = UserDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [4 /*yield*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var userWithCustomData = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = UserWithCustomDataDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [4 /*yield*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var createOrg = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = CreateOrgDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [4 /*yield*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var deleteOrg = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = DeleteOrgDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [4 /*yield*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var isDenied = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = IsActionDeniedDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [4 /*yield*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var checkPasswordStrength = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = CheckPasswordStrengthDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var registerByEmail = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = RegisterByEmailDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var loginByEmail = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        query = LoginByEmailDocument;
        token = tokenProvider.getToken();
        return [2 /*return*/, garpqhlClient.request({
                query: query,
                token: token,
                variables: variables
            })];
    });
}); };
export var loginByUsername = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        query = LoginByUsernameDocument;
        token = tokenProvider.getToken();
        return [2 /*return*/, garpqhlClient.request({
                query: query,
                token: token,
                variables: variables
            })];
    });
}); };
export var loginByPhoneCode = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        query = LoginByPhoneCodeDocument;
        token = tokenProvider.getToken();
        return [2 /*return*/, garpqhlClient.request({
                query: query,
                token: token,
                variables: variables
            })];
    });
}); };
export var loginByPhonePassword = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        query = LoginByPhonePasswordDocument;
        token = tokenProvider.getToken();
        return [2 /*return*/, garpqhlClient.request({
                query: query,
                token: token,
                variables: variables
            })];
    });
}); };
export var loginBySubAccount = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        query = LoginBySubAccountDocument;
        token = tokenProvider.getToken();
        return [2 /*return*/, garpqhlClient.request({
                query: query,
                token: token,
                variables: variables
            })];
    });
}); };
export var registerByUsername = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        query = RegisterByUsernameDocument;
        token = tokenProvider.getToken();
        return [2 /*return*/, garpqhlClient.request({
                query: query,
                token: token,
                variables: variables
            })];
    });
}); };
export var registerByPhoneCode = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        query = RegisterByPhoneCodeDocument;
        token = tokenProvider.getToken();
        return [2 /*return*/, garpqhlClient.request({
                query: query,
                token: token,
                variables: variables
            })];
    });
}); };
export var addRole = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = CreateRoleDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [4 /*yield*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var assignRole = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = AssignRoleDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [4 /*yield*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var revokeRole = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = RevokeRoleDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [4 /*yield*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var addMember = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = AddMemberDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [4 /*yield*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var moveMembers = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = MoveMembersDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [4 /*yield*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var getMembersById = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = NodeByIdWithMembersDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [4 /*yield*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var getMembersByCode = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = NodeByCodeWithMembersDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [4 /*yield*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var sendEmail = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = SendEmailDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [4 /*yield*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var sendFirstLoginVerifyEmail = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = SendFirstLoginVerifyEmailDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [4 /*yield*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var resetPassword = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = ResetPasswordDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var resetPasswordByFirstLoginToken = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = ResetPasswordByFirstLoginTokenDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var resetPasswordByForceResetToken = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = ResetPasswordByForceResetTokenDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var users = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = UsersDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var usersWithCustomData = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = UsersWithCustomDataDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var archivedUsers = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = ArchivedUsersDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var updateUserpool = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = UpdateUserpoolDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var updateUser = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = UpdateUserDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var searchUser = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = SearchUserDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var searchUserWithCustomData = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = SearchUserWithCustomDataDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var findUser = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = FindUserDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var findUserWithCustomData = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = FindUserWithCustomDataDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var createUser = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = CreateUserDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var deleteUser = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = DeleteUserDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var deleteUsers = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = DeleteUsersDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var roles = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = RolesDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var role = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = RoleDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var roleWithUsers = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = RoleWithUsersDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var roleWithUsersWithCustomData = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = RoleWithUsersWithCustomDataDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var updateRole = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = UpdateRoleDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var addNode = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = AddNodeV2Document;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var updateNode = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = UpdateNodeDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var deleteNode = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = DeleteNodeDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var nodeById = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = NodeByIdDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var moveNode = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = MoveNodeDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var removeMembers = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = RemoveMemberDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var refreshToken = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = RefreshTokenDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var isUserExists = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = IsUserExistsDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var updatePassword = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = UpdatePasswordDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var updatePhone = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = UpdatePhoneDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var updateEmail = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = UpdateEmailDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var bindPhone = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = BindPhoneDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var bindEmail = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = BindEmailDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var unbindPhone = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = UnbindPhoneDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var userBatch = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = UserBatchDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var userBatchWithCustomData = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = UserBatchWithCustomDataDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var getUserRoles = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = GetUserRolesDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var getUserDepartments = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = GetUserDepartmentsDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var setMainDepartment = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = SetMainDepartmentDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var allow = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = AllowDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var getWhiteList = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = WhitelistDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var removeWhiteList = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = RemoveWhitelistDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var addWhiteList = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = AddWhitelistDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var udv = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = UdvDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var udfValueBatch = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = UdfValueBatchDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var setUdv = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = SetUdvDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var setUdvBatch = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = SetUdvBatchDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var setUdfValueBatch = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = SetUdfValueBatchDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var removeUdv = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = RemoveUdvDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var setUdf = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = SetUdfDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var removeUdf = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = RemoveUdfDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var udf = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = UdfDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var deleteRole = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = DeleteRoleDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var deleteRoles = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = DeleteRolesDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var policies = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = PoliciesDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var createPolicy = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = CreatePolicyDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var policy = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = PolicyDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var updatePolicy = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = UpdatePolicyDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var deletePolicy = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = DeletePolicyDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var deletePolicies = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = DeletePoliciesDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var policyAssignments = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = PolicyAssignmentsDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var addPolicyAssignments = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = AddPolicyAssignmentsDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var removePolicyAssignments = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = RemovePolicyAssignmentsDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var enablePolicyAssignment = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = EnablePolicyAssignmentDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var disablePolicyAssignment = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = DisbalePolicyAssignmentDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var checkLoginStatus = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = CheckLoginStatusDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var getGroups = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = GroupsDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var group = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = GroupDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var groupWithUsers = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = GroupWithUsersDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var groupWithUsersWithCustomData = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = GroupWithUsersWithCustomDataDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var createGroup = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = CreateGroupDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var updateGroup = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = UpdateGroupDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var deleteGroups = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = DeleteGroupsDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var addUserToGroup = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = AddUserToGroupDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var removeUserFromGroup = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = RemoveUserFromGroupDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var getUserGroups = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = GetUserGroupsDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var unbindEmail = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = UnbindEmailDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var getAccessToken = function (garpqhlClient, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query;
    return __generator(this, function (_a) {
        query = AccessTokenDocument;
        return [2 /*return*/, garpqhlClient.request({
                query: query,
                variables: variables
            })];
    });
}); };
export var refreshAccessToken = function (garpqhlClient, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query;
    return __generator(this, function (_a) {
        query = RefreshTokenDocument;
        return [2 /*return*/, garpqhlClient.request({
                query: query,
                variables: variables
            })];
    });
}); };
export var listUserAuthorizedResources = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = ListUserAuthorizedResourcesDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var listRoleAuthorizedResources = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = ListRoleAuthorizedResourcesDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var listGroupAuthorizedResources = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = ListGroupAuthorizedResourcesDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var listNodeByIdAuthorizedResources = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = ListNodeByIdAuthorizedResourcesDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var listNodeByCodeAuthorizedResources = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = ListNodeByCodeAuthorizedResourcesDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var listAuthorizedResources = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = AuthorizedResourcesDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var authorizeResource = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = AuthorizeResourceDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var authorizedTargets = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = AuthorizedTargetsDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var searchNodes = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = SearchNodesDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
//# sourceMappingURL=graphqlapi.js.map